import customData from '../customData.json'

export const getShopInfo = (params) => {
  return fetch(`${customData.getShopInfoApi}?shopid=${encodeURIComponent(params.shopId)}&lang=${params.lang}&memberid=${params.memberid}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      // 'Content-Type': 'application/json',
    },
  }).then((res) => res.json());
}


export const getShopAddress = (params) => {
  return fetch(customData.getShopBranchDetailAPI, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      // 'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

export const getShopDescription = (params) => {
  return fetch(`${customData.apiPath}/getShopDescriptionAPI`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      // 'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  }).then((res) => res.json());
}